// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".add-permission-btn[data-v-02de735b]{background-color:#ff9f43;border:none;color:#fff;padding:8px 16px;border-radius:6px}.add-permission-btn[data-v-02de735b]:hover{background-color:#e68e35}.page-btn[data-v-02de735b]{padding-right:12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
